export default "__VITE_PUBLIC_ASSET__03085da5__"